import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Holiday } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { SettingsService } from 'src/app/shared/services/settings.service';

@Component({
  selector: 'app-holiday-crud',
  templateUrl: './holiday-crud.component.html',
  styleUrls: ['./holiday-crud.component.scss'],
})
export class HolidayCrudComponent implements OnInit {
  @Input() holiday: Holiday;
  @Input() context: Context;
  @Input() holidays: Holiday[] = [];
  public holidayTypes: string[] = [];
  public holidayForm: FormGroup;
  public minDate: string = "";
  public maxDate: string = "";
  public submitted: boolean = false;
  private modified: boolean = false;

  constructor(
    private settingsService: SettingsService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.holidayTypes = this.settingsService.getHolidayTypes();
    const years = this.commonService.generateYears(5);
    this.minDate = `${years[0]}-01-01`;
    this.maxDate = `${years[years.length - 1]}-12-31`;
    console.log(this.holiday)
    this.setHoliday(this.holiday);
  }

  public setHoliday(holiday?: Holiday) {
    if (!holiday)
      holiday = {
        id: null,
        name: "",
        label: null,
        date: "",
        companyId: this.context.companyId,
        optional: false,
        disabled: false,
      } as Holiday;
    this.holidayForm = this.fb.group({
      id: this.fb.control(holiday?.id || null),
      name: this.fb.control(holiday.name, [Validators.required, Validators.pattern(RegExp.holidayName)]),
      label: this.fb.control(holiday.label, [Validators.required, Validators.pattern(RegExp.letters)]),
      date: this.fb.control(holiday.date, [Validators.required]),
      companyId: this.fb.control(holiday.companyId, [Validators.required]),
      disabled: this.fb.control(holiday.disabled, []),
      optional: this.fb.control(holiday.optional, []),
    });
    this.holidayForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.holidayForm.controls;
  }

  public saveHoliday(inProgress?: any) {
    this.submitted = true;
    if (this.holidayForm.valid) {
      const holiday: Holiday = this.holidayForm.value;
      if (this.holidays.some(h => h.name.toLowerCase() === holiday.name.toLowerCase())) {
        this.commonService.setToastr(400, `Holiday ${holiday.name} already exists!`);
        inProgress.value = false;
        return;
      }
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Holiday ${holiday.name} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (holiday.id) {
        this.settingsService.updateHoliday(holiday.id, holiday).subscribe({
          next: (response: Holiday) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Holiday ${response.name} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          // error: (error: HttpErrorResponse) => {
          //   inProgress.value = false;
          //   this.commonService.setToastr(500, error?.error?.name || error.error);
          // },
        });
      } else {
        inProgress.value = false;
        this.settingsService.createHoliday(holiday).subscribe({
          next: (response: Holiday) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Holiday ${response.name} has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          // error: (error: HttpErrorResponse) => {
          //   inProgress.value = false;
          //   this.commonService.setToastr(500, error?.error?.name || error.error);
          // },
        });
      }
    }
  }
}
